import React, {Component} from "react";
import CmForm from "../../../../../components/CmForm/CmForm";
import CmModal from "../../../../../components/CmModal/CmModal";
import {Form, Input, Tooltip} from "antd";
import {validatePassword} from "../../../../../utils";
import {message} from "../../../utils/sysManagementUtils";

export default class ResetPwdModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pwd: "",
            pwdAgain: ""
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.visible&&prevProps.visible !== this.props.visible) {
            this.setState({
                pwd: "",
                pwdAgain: "",
                newVisibleCapsLock: false,
                againVisibleCapsLock: false
            });
        }
    }

    render() {
        const {
            visible,
            onKeyDown=()=>{},
        } = this.props;
        const {
            pwd,
            pwdAgain
        } = this.state;
        return (
            <>

                <CmModal
                    title={`重置密码`}
                    visible={visible}
                    handleCancel={this.handleCancel}
                    handleOk={this.handleOk}
                    destroyOnClose={true}
                    width={400}
                >
                    <CmForm>
                        <Form.Item
                            label="新设密码"
                            required
                            labelCol={{span:5}}
                            wrapperCol={{span:17, offset: 1}}
                        >
                            <Tooltip visible={this.state.newVisibleCapsLock} placement="topLeft" title="大写锁定已打开">
                                <Input.Password
                                    placeholder="请输入新设密码"
                                    onChange={e => this.setState({pwd: e.target.value.trim()})}
                                    value={pwd}
                                    maxLength={20}
                                    onKeyDown={e => {
                                        onKeyDown(e);
                                        const ifCapsLock = e.getModifierState("CapsLock");
                                        if (e.keyCode === 20 && ifCapsLock) {
                                            if (document.msCapsLockWarningOff == false) { // 关闭ie默认的大写锁定提示
                                                document.msCapsLockWarningOff = true;
                                            }
                                            this.setState({
                                                newVisibleCapsLock: true
                                            });
                                            setTimeout(() => {
                                                this.setState({
                                                    newVisibleCapsLock: false
                                                });
                                            }, 1000)
                                        }
                                    }}
                                />
                            </Tooltip>
                        </Form.Item>

                        <Form.Item
                            label="确认密码"
                            required
                            labelCol={{span:5}}
                            wrapperCol={{span:17, offset: 1}}
                        >
                            <Tooltip visible={this.state.againVisibleCapsLock} placement="topLeft" title="大写锁定已打开">
                                <Input.Password
                                    placeholder="请再次确认新设密码"
                                    onChange={e => this.setState({pwdAgain: e.target.value.trim()})}
                                    value={pwdAgain}
                                    maxLength={20}
                                    onKeyDown={e => {
                                        onKeyDown(e);
                                        const ifCapsLock = e.getModifierState("CapsLock");
                                        if (e.keyCode === 20 && ifCapsLock) {
                                            if (document.msCapsLockWarningOff == false) { // 关闭ie默认的大写锁定提示
                                                document.msCapsLockWarningOff = true;
                                            }
                                            this.setState({
                                                againVisibleCapsLock: true
                                            });
                                            setTimeout(() => {
                                                this.setState({
                                                    againVisibleCapsLock: false
                                                });
                                            }, 1000)
                                        }
                                    }}
                                />
                            </Tooltip>
                        </Form.Item>
                        {/*<style>*/}
                        {/*    {`*/}
                        {/*    .lsy .ant-form-item-label{*/}
                        {/*        width:80px !important;*/}
                        {/*    }*/}
                        {/*    `}*/}
                        {/*</style>*/}
                    </CmForm>
                </CmModal>
            </>
        );
    }

    handleOk = () => {
        const {
            pwd,
            pwdAgain
        } = this.state;
        if (!pwd) {
            return message.error("请输入新设密码！");
        }
        if (!pwdAgain) {
            return message.error("请输入确认密码！");
        }
        if (!validatePassword(pwd)) {
            return message.error("密码为7-20字符，可使用数字，字母，特殊字符（._~!@#$^&*）！");
        }
        if (pwd !== pwdAgain) {
            return message.error("新设密码与确认密码输入不一致！");
        }
        this.props.handleOk(pwd);
    };

    handleCancel = () => {
        this.props.handleCancel();
    };
}
